<template>
  <div id="ads-tab">
    <vue-tabs ref="adTabsContainer">
      <v-tab v-for="(adset, index) in value.adsets" :key="'adset-ads-' + index" :tabKey="'adset-ads-' + index" :hasError="value.adsets[index].hasError">
        <!-- Start title -->
        <div slot="title">
          <span class="align-middle pl-3 adset-title">
            {{ value.adsets[index].name == '' ? ('Ad Set ' + (index + 1)) : value.adsets[index].name }}
          </span>
        </div>
        <!-- End title -->

        <!-- Start content -->
        <div class="mt-2">
          <AdsetAds
            v-model="value.adsets[index].ads"
            :adsetIndex="index"
            :serverErrors="serverErrors"
            :advertising-channel="advertisingChannel"
            :objective="objective"
            :objective-id="objectiveId"
            :type="type"
            :language="value.adsets[index].language === 1 ? 'english' : 'arabic'"
            :editing="editing"
            :adset="value.adsets[index]"
          />
        </div>
        <!-- End content -->
      </v-tab>
    </vue-tabs>
  </div>
</template>

<script>
import {
  VueTabs,
  VTab
} from '@/components/vue-nav-tabs/vue-nav-tabs.js'

import AdsetAds from '@/views/campaigns/components/steps/components/AdsetAds/AdsetAds.vue'

export default {
  props: {
    value: {
      required: true,
      type: Object
    },
    serverErrors: {
      required: true
    },
    advertisingChannel: {
      type: Object,
      required: true
    },
    objective: {
      type: String,
      required: true
    },
    objectiveId: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    editing: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  components: {
    VueTabs,
    AdsetAds,
    VTab
  },
  watch: {
    value: {
      handler (newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  mounted () {
    // if the url param has ?adset=x will activate the tab with id x
    if (this.$route.query.adset || 0) {
      setTimeout(() => {
        const indexToActivate = this.value.adsets.findIndex(i => i.id === parseInt(this.$route.query.adset))
        if (indexToActivate > -1) {
          this.$refs.adTabsContainer.findTabAndActivate(`adset-ads-${indexToActivate}`)
        }
      }, 0)
    }
  }
}
</script>

<style lang="scss">
  #ads-tab {
    .tabs__link {
      padding-top: 15px;
      padding-bottom: 15px;
    }
  }
</style>
